var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"home-footer"},[_c('p',{staticClass:"copyright"},[_vm._v("©2026 Rad team // All rights reserved")]),_c('a',{staticClass:"telegram-link",attrs:{"href":"https://t.me/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" Telegram ")])])
}]

export { render, staticRenderFns }